import React from 'react';
import { Input, DatePicker, Icon, Row, Col, Select, Tag } from 'antd';
import moment from 'moment';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

const { Option } = Select;
class Filters extends React.Component {


    handleChange = (option) => {
        this.props.onChange("idCliente", option.key, "cliente", option.label[2].split('-')[0]);
    }

    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>

                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idEstablecimiento ?
                                    { key: this.props.filter.idEstablecimiento } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por establecimiento" />}
                            onChange={(option) => this.props.onChange("idEstablecimiento", option.key)}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            {this.props.establecimientos.map(item => (
                                <Option value={item.id} key={item.id} >{item.nombre}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idCaja ?
                                    { key: this.props.filter.idCaja } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por caja" />}
                            onChange={(option) => this.props.onChange("idCaja", option.key)}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            {this.props.filter.cajas.map(item => (
                                <Option key={item.id} value={item.id}>
                                    {item.nombre}
                                </Option>
                            ))}
                        </Select>

                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idEmpleado ?
                                    { key: this.props.filter.idEmpleado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por responsable" />}
                            onChange={(option) => this.props.onChange("idEmpleado", option.key, "empleado", option.label)}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            {this.props.empleados.map(item => (
                                <Option value={item.id} key={item.id} >{item.nombre}</Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idEstado ?
                                    { key: this.props.filter.idEstado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por estado" />}
                            onChange={(option) => this.props.onChange("idEstado", option.key)}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Option value={"0"} key={"0"} >TODOS</Option>
                            {this.props.estados.map(item => (
                                item.id != 1 ? <Option value={item.id} key={item.id} >{item.nombre}</Option>
                                    : null
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default Filters;